// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { commonVar } from "./common-env";

export const environment = {

  // Get all shared var between env
  ...commonVar,

  // specific vars
  production: true,
  supportEmail: 'support@klafuti.com',
  registrationUrl: 'https://www.klafuti.com/nous-contacter',
  apiURL: 'https://api.uat.klafuti.com/api',
  mixpanelToken: '',
  mixpanelDebug: true,
  featureFlagsRefreshInterval: 60,
  errorsWarningSettings: {
    enable: true,
    startingStatusCode: 500,
  },
  inqom: {
    oauth2: {
      authorizeUrl: 'https://auth.inqom.com/identity/connect/authorize',
      clientId: 'klafuti',
      scopes: 'openid apidata offline_access'
    }
  },
  nextMotion: {
    oauth2: {
      authorizeUrl: 'https://account.nextmotion.net/oauth2/authorize',
      clientId: '7nHWNT1jjleB7JKjpaiekNMRpERoa9tucQ9LoPJu',
      scopes: 'openid offline_access'
    }
  },
  documentation: {
    dex: {
      import: 'https://drive.google.com/file/d/1xIQIYRSRMc8pwcxkq43rwLNdaos3IRnp/view'
    },
    ascii: {
      import: 'https://drive.google.com/file/d/14f9ywLtt3-dTmLHzhLx5s5ghz2PQfk_C/view?usp=sharing'
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
